import { render, staticRenderFns } from "./PlanesCumulativeEmissions.vue?vue&type=template&id=43fc145f&scoped=true"
import script from "./PlanesCumulativeEmissions.vue?vue&type=script&lang=js"
export * from "./PlanesCumulativeEmissions.vue?vue&type=script&lang=js"
import style0 from "./PlanesCumulativeEmissions.vue?vue&type=style&index=0&id=43fc145f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc145f",
  null
  
)

export default component.exports